import { Fragment } from 'react';

import {
  countryDefinitions,
  countryName,
  zipCodeFormat
} from 'common/helpers/addresses';
import { phoneFormat } from 'common/helpers/phoneHelper';

const AddressDisplay = (props) => {
  const { address, boldName } = props;
  const viewArray = countryDefinitions[address.countryCode].viewFormat;
  return (
    <>
      {renderName(address, boldName)}
      {renderAddressRow(viewArray, address)}
      {countryName(address.countryCode)}
      <br />
      {renderPhoneNumber(address)}
    </>
  );
};

export default AddressDisplay;

const renderName = (address, boldName) => {
  if (!address.firstName && !address.lastName) {
    return null;
  }
  if (boldName) {
    return (
      <>
        <strong>
          {address.firstName} {address.lastName}
        </strong>
        <br />
      </>
    );
  }
  return (
    <>
      {address.firstName} {address.lastName}
      <br />
    </>
  );
};

const renderAddressRow = (viewFormat, address) =>
  viewFormat.map((addressRow) => {
    // Do we need to render;
    let render = false;
    for (let i = 0; i < addressRow.length; i += 1) {
      if (address[addressRow[i]]) {
        render = true;
        break;
      }
    }
    if (!render) {
      return null;
    }
    return (
      <Fragment key={addressRow[0]}>
        {renderAddressElement(addressRow, address)}
        <br />
      </Fragment>
    );
  });

const renderAddressElement = (addressRow, address) =>
  addressRow.map((addressElement) => {
    if (addressElement === 'space') {
      return ' ';
    }
    if (addressElement === 'comma') {
      return ', ';
    }
    if (addressElement === 'zipCode') {
      return zipCodeFormat(address[addressElement], address.countryCode);
    }
    return address[addressElement];
  });

const renderPhoneNumber = (address) => {
  if (address.phone) {
    return <>Phone: {phoneFormat(address.phone, address.countryCode)}</>;
  }
  return null;
};
